<template>
    <div class="main-content" v-if="settings">
        <b-card class="p-4">
            <div class="row">
                <div class="col-7">
                    Pergunta: <br>
                    <p class="text-15 font-weight-bold">{{ settings.pulse }}</p>
                    <b-form-group :label="dayLabel" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="radio-days"
                            v-model="settings.day"
                            :options="availableDays"
                            :aria-describedby="ariaDescribedby"
                            name="radio-days"
                            buttons
                        ></b-form-radio-group>
                    </b-form-group>
                    <b-form-group
                        label="às:"
                        label-for="input-name"
                        class="w-25"
                    >
                        <b-form-select v-model="settings.hour" :options="availableHours"></b-form-select>
                    </b-form-group>
                </div>
                <div class="col-3 offset-2">
                    <div class="form-group mb-3">
                        <label for="">Ativo</label>
                        <div style="font-weight: 600;">
                            <label class="switch switch-primary mr-3">
                                <span>{{ !settings.active ? 'Não' : 'Sim' }}</span>
                                <input type="checkbox" v-model="settings.active"/>
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group mb-3">
                        <b-btn
                            variant="link"
                            class="p-0"
                            @click="viewPulse = !viewPulse"
                        >
                            Visualizar pergunta
                        </b-btn>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <b-button
                @click="editSettings"
                variant="primary"
                class="btn"
            >
                Salvar
            </b-button>
            <b-button
                @click="sendEmail"
                variant="secondary"
                class="btn ml-2"
                :disabled="loading"
            >
                Enviar Agora
                <b-spinner v-if="loading" variant="primary" class="spinner-border ml-1"></b-spinner>
            </b-button>
        </b-card>
        <b-modal
            v-model="viewPulse"
            title="Pulse Happiness"
            modal-class="pulse-modal"
            size="lg"
            ok-only
        >
            <h4>{{ settings.pulse }}</h4>
            <p>Selecione clicando abaixo:</p>
            <div class="d-flex flex-row-reverse justify-content-center align-items-center text-18">
                <response-emoji
                    v-for="(emoji, index) in settings.emojis"
                    :key="`emoji-${emoji}`"
                    :response="index"
                    :hasText="true"
                    class="m-2 px-2 py-1 border rounded"
                    size="30px"
                />
            </div>
            <hr class="mt-1 mb-3" />
            <br />
            <p>Este e-mail foi enviado pelo sistema Pipu.</p>
        </b-modal>
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

export default {
    name: 'HappinessSettings',
    data () {
        return {
            loading: false,
            viewPulse: false,
            availableDays: [
                { text: 'Dom', value: 0 },
                { text: 'Seg', value: 1 },
                { text: 'Ter', value: 2 },
                { text: 'Qua', value: 3 },
                { text: 'Qui', value: 4 },
                { text: 'Sex', value: 5 },
                { text: 'Sáb', value: 6 },
            ],
            availableHours: [
                { text: '09:00', value: 9 },
                { text: '11:00', value: 11 },
                { text: '13:00', value: 13 },
                { text: '15:00', value: 15 },
            ],
            initialized: false,
        }
    },
    components: {
        ResponseEmoji: () => import('@/components/Emojis/ResponseEmoji'),
    },
    methods: {
        includeNeutral () {
            var include = this.settings.includeNeutral = !this.settings.includeNeutral
            if (include && this.settings.emojis.length === 4) {
                this.settings.emojis.unshift('unhappy')
            }
            if (!include && this.settings.emojis.length === 5) {
                this.settings.emojis.splice(1, 1)
            }
        },
        editSettings () {
            const data = {
                uid: this.settings.uid,
                data: this.settings,
            }

            this.$store
                .dispatch('settings/editSettings', data)
                .then(() => {
                    this.$bvToast.toast('Configuração salva.', {
                        title: 'Salvo!',
                        toaster: 'b-toaster-bottom-right',
                        variant: 'success',
                    })
                })
                .catch(() => {
                    this.$bvToast.toast('Erro ao salvar configuração.', {
                        title: 'Ops!',
                        toaster: 'b-toaster-bottom-right',
                        variant: 'danger',
                    })
                })
        },
        loadSettings () {
            this.$store.dispatch('settings/loadSettings')
        },
        sendEmail () {
            this.loading = true
            auth
                .currentUser
                .getIdToken()
                .then((token) => {
                    api
                        .get('/mail/send', {
                            headers: {
                                token,
                            },
                        })
                        .then(() => {
                            this.$bvToast.toast('E-mail enviado!', {
                                title: 'Enviado!',
                                toaster: 'b-toaster-bottom-right',
                                variant: 'success',
                            })
                        })
                        .catch(() => {
                            this.$bvToast.toast('Erro ao Enviar e-mal.', {
                                title: 'Ops!',
                                toaster: 'b-toaster-bottom-right',
                                variant: 'danger',
                            })
                        })
                        .finally(() => {
                            this.loading = false
                        })
                })
        },
    },
    computed: {
        settings () {
            return this.$store.getters['settings/settings']
        },
        dayLabel () {
            return [0, 6].includes(this.settings.day)
                ? 'Enviar no:'
                : 'Enviar na:'
        },
    },
    created () {
        this.loadSettings()
    },
    mounted () {
        window.sendEmail = this.sendEmail
    },
}
</script>

<style lang="scss">
.pulse-modal {
    .modal-dialog {
        width: 60%;
    }
}
.spinner-border {
    width: 1rem;
    height: 1rem;
}
</style>
